"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAllResolver = makeAllResolver;

var _ReferenceRecord = _interopRequireDefault(require("../schema/ReferenceRecord"));

var _Strategy = require("./Strategy");

var _enforce = require("../lib/enforce");

var enforceResolverValue = (0, _enforce.createEnforceResolverValue)('Immutable.Iterable of ReferenceRecords', _ReferenceRecord.default.isReferenceIterable);

function makeAllResolver(getSubscription) {
  var all = null;
  return function () {
    if (!all) {
      all = (0, _Strategy.bridgeAtom)(function (next) {
        var remove = (0, _Strategy.enforceRemoveFunction)(getSubscription(function (records) {
          return next(enforceResolverValue(records));
        }));
        return function () {
          remove();
          all = null;
        };
      });
    }

    return all;
  };
}